import React from "react";

const Approved = () => {
  return (
    <span class="label label-xl label-light-success label-inline w-100 font-weight-bold">
      Approved
    </span>
  );
};

export default Approved;
